"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var page_header_html_1 = __importDefault(require("./page-header.html"));
require("./page-header.less");
require("@components/page/page-margin-positioner/page-margin-positioner");
(function (module) {
    module.directive('prPageHeader', function () {
        return { templateUrl: page_header_html_1.default };
    });
})(angular_1.module('qualtrics.pr'));
